<template>
  <div class="music-wave-box">
    <EditorWavePlayer
      ref="refWaveMusic"
      :autoToStartIfNotCurrent="false"
      :canSeekNotCurrent="true"
      :url="url"
      :duration="duration"
      :waveformData="waveformData"
      :hideRemove="hideRemove"
      :progress="progress"
      @remove="remove"
      @syncProgress="syncProgress"
      @changeProgress="changeProgress"
      @togglePlay="doTogglePlay"
    ></EditorWavePlayer>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";
import EditorWavePlayer from "../../component/editorWavePlayer.vue";

const props = defineProps({
  url: {
    type: String,
    default: "",
  },
  duration: {
    type: Number,
    default: 0,
  },
  waveformData: {
    type: Array,
    default: () => {
      return [];
    },
  },
  progress: {
    type: Number,
    default: 0, // 0 表示起点
  },
  hideRemove: {
    type: Boolean,
    default: false, // 0 表示起点
  }
});
const refWaveMusic = ref(null);
const emits = defineEmits(["changeProgress", "syncProgress", "remove", "doTogglePlay"]);

const changeProgress = (progress) => {
  emits("changeProgress", progress);
};

const syncProgress = (progress, startTime) => {
  emits("syncProgress", progress, startTime);
};

const remove = () => {
  emits("remove");
}

const doTogglePlay = (isPlay) => {
  emits("doTogglePlay", isPlay);
}

defineExpose({
  changeProgress: (progress) => {
    console.log(progress, "defineExpose--changeProgress-")
    refWaveMusic.value?.changeProgress(progress);
  },
  changeOp: (isPlaying) => {
    refWaveMusic.value?.changeOp(isPlaying);
  }
});
</script>

<style lang="scss" scoped>
.music-wave-box {
  height: 100%;
}
</style>
